/**
 * Utility functions for scroll management
 */

/**
 * Reset scroll position to top for window and common scrollable containers
 * @param {Object} options - Configuration options
 * @param {boolean} options.smooth - Whether to use smooth scrolling (default: false)
 * @param {string[]} options.selectors - Additional selectors to reset scroll for
 */
export const resetScrollPosition = (options = {}) => {
    const { smooth = false, selectors = [] } = options;
    const behavior = smooth ? 'smooth' : 'instant';

    // Reset main window scroll
    window.scrollTo({ top: 0, left: 0, behavior });

    // Reset scroll for main content area
    const mainElement = document.querySelector('main');
    if (mainElement) {
        mainElement.scrollTop = 0;
    }

    // Reset scroll for body
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    // Reset scroll for common scrollable containers
    const defaultSelectors = [
        '[data-scrollable]',
        '.overflow-auto',
        '.overflow-y-auto', 
        '.overflow-scroll',
        '.h-screen',
        '.min-h-screen'
    ];

    const allSelectors = [...defaultSelectors, ...selectors];
    
    allSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
            element.scrollTop = 0;
        });
    });
};

/**
 * Disable scroll restoration by the browser
 */
export const disableBrowserScrollRestoration = () => {
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }
};

/**
 * Enable scroll restoration by the browser
 */
export const enableBrowserScrollRestoration = () => {
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'auto';
    }
};